import data from './Sailing.yaml'
import { WithPage } from "../Components/PageSections/WithPage";

export default function Sailing() {

  return WithPage(data, 'sailing')

}